angular.module('bmsApp.marketing').controller('CampaignSaveCtrl', [
	'$scope',
	'$rootScope',
	'$log',
	'CampaignSvc',
	'ngTableParams',
	'$state',
	'$window',
	'$q',
	'LicenseOptionsSvc',
	'notify',
	function ($scope, $rootScope, $log, CampaignSvc, ngTableParams, $state, $window, $q, LicenseOptionsSvc, notify) {

		$scope.loading = true;
		$scope.processing = false;
		$scope.updating = ($state.is('main.marketing.campaignIndex.campaignUpdate')) ? true : false;
		$scope.formValidator = {};
		$scope.campaign = {};
		$scope.campaignDateRange = {};

		$scope.campaignDurationOptions = $scope.config.datePicker.range;
		$scope.campaignDurationOptions.options.ranges = {};

		var promises = [];
		promises.push(LicenseOptionsSvc.license());

		if ($scope.updating) {
			promises.push(CampaignSvc.read($state.params.campaignId));
		}

		$q.all(promises).then(function (responses) {
			$scope.licenses = responses[0].data.options;
			if ($scope.updating) {
				$scope.campaign = responses[1].data.campaign;
				$scope.campaignDateRange = {
					startDate: $scope.campaign.start_date,
					endDate: $scope.campaign.end_date
				};
			}

			$scope.loading = false;
		});

		$scope.submit = function (campaign) {
			if ($scope.formValidator.valid()) {
				$scope.processing = true;

				campaign.start_date = $scope.campaignDateRange.startDate;
				campaign.end_date = $scope.campaignDateRange.endDate;

				var promise;
				promise = (campaign.id) ?
					CampaignSvc.update(campaign) :
					CampaignSvc.create(campaign);

				promise.then(function (response) {
					notify({
						message: $scope.updating ? 'Campaign updated successfully' : 'Campaign created successfully'
					});
					$state.go('main.marketing.campaignIndex');
				}, function (error) {
					$scope.errors = error;
				})
					.finally(function () {
						$scope.processing = false;
					});
			}
		};

	}]);


